var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('vpreloader',{attrs:{"width":"2","size":"64"}}):(_vm.error)?_c('error-view',{attrs:{"error":_vm.error},on:{"reload":_vm.fetch}}):_c(_vm.way,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }